/**
 * Feature-list rewrites for seatless (credits-pricing) checkout surfaces.
 *
 * Seatless orgs have no per-builder allowance and no seat purchases: the
 * pack pool is shared org-wide and teammates are invited freely rather than
 * seated — so the seat-scaling framing becomes an invite framing. Both the
 * credit-card gate and the AI quota paywall advertise the same Teams plan,
 * so the rewrites live here instead of being duplicated inline.
 */

const PER_BUILDER_LINE = "100 GAUs per AI Builder / month";
const SEAT_SCALING_LINE = "Scale team up to 15 Builders";
const INVITE_LINE = "Invite up to 15 Builders";

/**
 * AI & GAUs list: the per-builder line becomes shared-pool copy sized to the
 * selected pack.
 */
export function seatlessAiFeatureList(
  baseFeatures: readonly string[],
  packCredits: number,
): string[] {
  return baseFeatures.map((feature) =>
    feature === PER_BUILDER_LINE
      ? `${packCredits.toLocaleString("en-US")} GAUs / month shared across your team`
      : feature,
  );
}

/**
 * Platform list: the seat-scaling line becomes the invite line in place —
 * same slot, seat framing replaced with invite framing since builders draw
 * on the shared pool instead of individual seats.
 */
export function seatlessPlatformFeatureList(
  baseFeatures: readonly string[],
): string[] {
  return baseFeatures.map((feature) =>
    feature === SEAT_SCALING_LINE ? INVITE_LINE : feature,
  );
}
